/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserSession interface.
 */
export function instanceOfUserSession(value) {
    var isInstance = true;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "lastAccess" in value;
    return isInstance;
}
export function UserSessionFromJSON(json) {
    return UserSessionFromJSONTyped(json, false);
}
export function UserSessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
        'start': json['start'],
        'lastAccess': json['lastAccess']
    };
}
export function UserSessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ipAddress': value.ipAddress,
        'start': value.start,
        'lastAccess': value.lastAccess
    };
}
